import { land_group_id } from "src/libs/layouts"
import { isRole, useUser } from "src/settings/zustand/user"
import { useEffect, useState } from "react"
import actions from "src/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION } from "src/modules/pe-basic-module/data/actionTypes"
import { LANDS_PAGINATION, LANDS_PAGINATION_TYPE } from "../data/interfaces"

export default function useLands( type?: LANDS_PAGINATION_TYPE ) : boolean { 
    const user = useUser()
    const getLandsPaging = () => {        
        if(isRole(["administrator", "SuperAdmin"])) {
            if( !!land_group_id() ) {
                return ` meta_relation: "AND"  metas: [ { key: "land_group_id", value: "${ land_group_id() }" } ]`
            }
            else {
                return ` ` 
            }
        }
        else {
            switch(type) {
                case LANDS_PAGINATION_TYPE.MODERATION:
                    return ` meta_relation: "AND"  metas: [ {key : "demiurg_id", value: "${user.id}"} ] `
                default:
                    return LANDS_PAGINATION
            } 
        } 
    }
    const [isLoad, setIsLoad] = useState<boolean>(false)
    const getLands = () => {
        actions(GET_FEED_ACTION, {
            data_type: "Land",
            paging: getLandsPaging()
        })
        .then(() => setIsLoad(true))
    } 
    useEffect(() => getLands(), []) 
    return isLoad
}